import { type FridgeState, LightingModeType, TransactionState } from "types";
import { AppState } from "types/mainTypes";

export type ConvergenceInput = {
	appState: AppState;
	hasOrder: boolean;
	orderState: TransactionState | undefined;
	fridgeState: FridgeState | null;
	openDetailDishTypeId: string | null;
	allergens: string[];
	filteredDishTypeIds: readonly string[];
};

export type DesiredFridgeLighting =
	| { kind: "be-authoritative" }
	| { kind: "fe-driven"; mode: LightingModeType; spotlightDishTypeIds: readonly string[] };

// Precedence: Finished > (IDLE && !hasOrder) > allergen-filter > detail-open > default Active.
export const computeDesiredLighting = (input: ConvergenceInput): DesiredFridgeLighting => {
	if (input.orderState === TransactionState.Finished) {
		return { kind: "be-authoritative" };
	}

	if (input.appState === AppState.IDLE && !input.hasOrder) {
		return { kind: "fe-driven", mode: LightingModeType.StandBy, spotlightDishTypeIds: [] };
	}

	if (input.allergens.length > 0 && input.orderState !== TransactionState.StockCheck) {
		if (input.openDetailDishTypeId !== null && input.filteredDishTypeIds.includes(input.openDetailDishTypeId)) {
			return {
				kind: "fe-driven",
				mode: LightingModeType.Active,
				spotlightDishTypeIds: [input.openDetailDishTypeId],
			};
		}

		return {
			kind: "fe-driven",
			mode: LightingModeType.Active,
			spotlightDishTypeIds: input.filteredDishTypeIds,
		};
	}

	if (input.openDetailDishTypeId !== null) {
		return {
			kind: "fe-driven",
			mode: LightingModeType.Active,
			spotlightDishTypeIds: [input.openDetailDishTypeId],
		};
	}

	return { kind: "fe-driven", mode: LightingModeType.Active, spotlightDishTypeIds: [] };
};
